import React, { useState, useRef, useEffect } from "react";






 import spypeIcon7 from "../../media/images/fIcon/body_polish_1_.png"
 import spypeIcon6 from "../../media/images/fIcon/body_polish_2_.png" 
 import spypeIcon5 from "../../media/images/fIcon/mani_pedi.png"
 import spypeIcon4 from "../../media/images/fIcon/hair_spa.png"
 import spypeIcon3 from "../../media/images/fIcon/bleach_D-tan_with_scrub_1.png" 
 import spypeIcon2 from "../../media/images/fIcon/facial_1_1.png" 
 import spypeIcon1 from "../../media/images/fIcon/waxing.png"



 import  spyIconBridal from "../../media/images/fIcon/briadalmakup.png"
 import  spyIconParty from "../../media/images/fIcon/body_polish.png" 
 import  spyIconhdres from "../../media/images/fIcon/hair-dressing-icone.png"
 import  spyIconpreB from "../../media/images/fIcon/preBdIcon.jpg"
 import  spyIconFree from "../../media/images/fIcon/free-icone.png"
 import  spyIconWed from "../../media/images/fIcon/wedingIcon.jpg"


import sypThreading  from "../../media/images/fIcon/threading.png"
import sypBDM  from "../../media/images/fIcon/body_and_head_massage.png" 
import sypPreBGroomig  from "../../media/images/fIcon/pre_brid_grooming.png"

import LandingPackageComponent from '../../components/user/LandingPackageComponent'

function FemaleServicesComponent() {

  //  const [ActiveService , setActiveService] = useState("waxing")
const toUrlSlug = (name) => name.replace(/ /g, "-");
const fromUrlSlug = (slug) => slug.replace(/-/g, " ");




const getInitialService = () => {
  const hash = fromUrlSlug(window.location.hash.substring(1));
  const validHashes = [
    "waxing",
    "Party Makeup",
    "Bridal Makeup",
    "Pre Bridal Grooming",
    "wedding package",
    "Facial Cleanup",
    "Body Polish",
    "Mani Pedi",
    "Hair Care",
    "Haircut",
    "Mehdi",
    "Nail Art"
  ];
  return validHashes.includes(hash) ? hash : "waxing";
};






const [ActiveService, setActiveService] = useState(getInitialService);



  const headingRefs = useRef({});

  const getHeadingRef = (key) => {
    if (!headingRefs.current[key]) {
      headingRefs.current[key] = React.createRef();
    }
    return headingRefs.current[key];
  };

  const scrollToHeading = (key) => {
    const ref = headingRefs.current[key];
    if (ref && ref.current) {
      const offset = 100; // Adjust if sticky nav height exists
      const top = ref.current.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
 


   }



useEffect(() => {
  const handleHashChange = () => {
     const hash = fromUrlSlug(window.location.hash.substring(1));

    // Sirf service hashes ko ActiveService banao
    const serviceHashes = [
      "waxing",
      "Party Makeup",
      "Bridal Makeup",
      "Pre Bridal Grooming",
      "wedding package",
      "Facial Cleanup",
      "Body Polish",
      "Mani Pedi",
      "Hair Care",
      "Haircut",
      "Mehdi",
      "Nail Art"
    ];

    if (serviceHashes.includes(hash)) {
      setActiveService(hash);
    }
  };

  handleHashChange();

  window.addEventListener("hashchange", handleHashChange);

  return () => {
    window.removeEventListener("hashchange", handleHashChange);
  };
}, []);












const handleServiceClick = (service) => {
  setActiveService(service);

  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}#${toUrlSlug(service)}`
  );
};


  return (
    <div className="female-show-services-component-bg">
      <div className="female-show-services-component-main-container">
        <div className="female-show-services-comp-main-nav-content">
          <div className="female-show-services-comp-inner-nav-content">
            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("waxing")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "waxing" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    <img src={spypeIcon1} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Waxing </div>
                </div>
              </div>

              {/* {
                     ActiveService === "waxing" ?
                     <div className='female-show-services-comp-ative-menu-content'>


                        <div>
                          <p  onClick={() => scrollToHeading("Rica Wax")}> Rica Wax</p>
                          <p  onClick={() => scrollToHeading("Rica Roll On Wax")}> Rica Roll-on Wax</p>
                          <p  onClick={() => scrollToHeading("Korean Wax")}>Korean Wax</p>

                        </div>
                     </div>

                     :""
                  } */}
            </div>

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Party Makeup")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Party Makeup" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={spyIconParty} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Party Makeup </div>
                </div>
                {/* <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div> */}
              </div>

              {/* {
                     ActiveService === "Party Makeup" ?
                     <div className='female-show-services-comp-ative-menu-content'>
                        <div>
                          <p  onClick={() => scrollToHeading("Party Makeup (Basic)")}> Party Makeup (Basic) </p>
                          <p  onClick={() => scrollToHeading("Festivals / Seasonal Makeup")}>Festivals / Seasonal Makeup</p>
                      
                    

                        </div>
                     </div>

                     :""
                  } */}
            </div>

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Bridal Makeup")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Bridal Makeup" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={spyIconBridal} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Bridal Makeup </div>
                </div>
                {/* <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div> */}
              </div>

              {/* {
                     ActiveService === "Bridal Makeup" ?
                     <div className='female-show-services-comp-ative-menu-content'>
                        <div>
                          <p  onClick={() => scrollToHeading("Basic Bridal Makeup")}> Basic Bridal Makeup</p>
                          <p  onClick={() => scrollToHeading("Bridal HD Makeup")}>Bridal HD Makeup</p>
                    

                        </div>
                     </div>

                     :""
                  } */}
            </div>

            {/* <div className='female-show-services-comp-menu-nav-content'  onClick={()=>handleServiceClick("Party Makeup")} >
                

                     <div className='female-show-services-comp-menu-nav-row'>
<div className={`${ActiveService === "Party Makeup" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={spypeIcon6} alt='i-c01'></img> </div>  <div>Makeup </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>
                   </div>


                       {
                     ActiveService === "Party Makeup" ?
                     <div className='female-show-services-comp-ative-menu-content'>
                        <div>
                          <p  onClick={() => scrollToHeading("Party Makeup (Basic)")}> Party Makeup (Basic) </p>
                          <p  onClick={() => scrollToHeading("Seasonal Makeup")}>Seasonal Makeup</p>
                            <p  onClick={() => scrollToHeading("Hairstyling")}> Hairstyling</p>
                        <p  onClick={() => scrollToHeading("Basic Bridal Makeup")}> Basic Bridal Makeup</p>
                          <p  onClick={() => scrollToHeading("Bridal HD Makeup")}>Bridal HD Makeup</p>
                    

                        </div>
                     </div>

                     :""
                  }
                   

                </div> */}

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Pre Bridal Grooming")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Pre Bridal Grooming" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={sypPreBGroomig} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div>Pre-Bridal Grooming </div>
                </div>
                {/* <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div> */}
              </div>
            </div>

            {/* 
    <div className='female-show-services-comp-menu-nav-content'
                 onClick={()=>handleServiceClick("wedding package")}
                  >
                     <div className='female-show-services-comp-menu-nav-row   '>

              
              
                  <div className={`${ActiveService === "wedding package" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>

                  
                   <div>     <img src={spyIconWed} alt='i-c01'></img>   </div>  <div> Wedding Packages  </div>
                   </div>
                

                   </div>


                {
                     ActiveService === "wedding package" ?
                     <div className='female-show-services-comp-ative-menu-content'>

                        <div>
                           <p  onClick={() => scrollToHeading("549 Deal")}> 549 deal</p>
                          <p  onClick={() => scrollToHeading("1099 Deal")}> 1099 deal</p>
                        <p  onClick={() => scrollToHeading("1599 Deal")}> 1599 deal</p>
                          <p  onClick={() => scrollToHeading("1999 Deal")}> 1999 deal</p>
                      <p  onClick={() => scrollToHeading("Advance Packages")}> Advance Packages</p>



                        </div>
                     </div>

                     :""
                  } 



                </div>  */}

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Facial Cleanup")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Facial Cleanup" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={spypeIcon2} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Facial & Cleanup </div>
                </div>
                {/* <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div> */}
              </div>

              {/* {
                     ActiveService === "Facial Cleanup" ?
                     <div className='female-show-services-comp-ative-menu-content'>
                        <div>
                          <p  onClick={() => scrollToHeading("Facial")}> Facial</p>
                          <p  onClick={() => scrollToHeading("Cleanup")}> Cleanup</p>
                        </div>
                     </div>

                     :""
                  }
             */}
            </div>

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Body Polish")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Body Polish" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    <img src={spypeIcon6} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Body Polish & Scrubbing </div>
                </div>

                {/* <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div> */}
              </div>

              {/* {
                     ActiveService === "Body Polish" ?
                     <div className='female-show-services-comp-ative-menu-content'>


                        <div>
                          <p  onClick={() => scrollToHeading("Polishing")}>Polishing</p>
                          <p  onClick={() => scrollToHeading("Scrub")}> Scrub</p>
                        

                        </div>
                     </div>

                     :""
                  } */}
            </div>

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Mani Pedi")}
            >
              <div className="female-show-services-comp-menu-nav-row  ">
                <div
                  className={`${ActiveService === "Mani Pedi" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={spypeIcon5} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div>Mani-Pedi </div>
                </div>
              </div>
            </div>

            {/* <div className='female-show-services-comp-menu-nav-content' 
                    onClick={()=>handleServiceClick("1rs services")}
                    >
            

                     <div className='female-show-services-comp-menu-nav-row '>
<div className={`${ActiveService === "1rs services" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div>    <img src={spyIconFree} alt='i-c01'></img>    </div>  <div> Services @ 1 </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                         {
                     ActiveService === "1rs services" ?
                     <div className='female-show-services-comp-ative-menu-content'>

                        <div>
                          <p  onClick={() => scrollToHeading("Free Waxing")}> Free Waxing</p>
                          <p  onClick={() => scrollToHeading("Free D Tan")}> Free D-Tan</p>
                          <p  onClick={() => scrollToHeading("Free Bleach")}> Free Bleach</p>
                          <p  onClick={() => scrollToHeading("Free Hair Color")}> Free Hair Color</p>
                        </div>
                     </div>

                     :""
                  }
                </div>  */}

            {/* <div className='female-show-services-comp-menu-nav-content' 
                     //  onClick={()=>handleServiceClick("Bleach & D-Tan")}
                      >
       

                     <div className='female-show-services-comp-menu-nav-row  female-show-services-comp-menu-nav-row-not-allow'>
<div className={`${ActiveService === "Bleach & D-Tan" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={spypeIcon3} alt='i-c01'></img>  </div>  <div> Skin Care </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>
                   </div>

                                           {
                     ActiveService === "Bleach & D-Tan" ?
                     <div className='female-show-services-comp-ative-menu-content'>
                        <div>
                          <p  onClick={() => scrollToHeading("Bleach")}> Bleach</p>
                          <p  onClick={() => scrollToHeading("D-Tan")}> D-Tan</p>
                          <p  onClick={() => scrollToHeading("Scrub")}>Scrub</p>
                          <p  onClick={() => scrollToHeading("Body Polish")}>Body Polish</p>



                        </div>
                     </div>

                     :""
                  }
              

                </div> */}

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Hair Care")}
            >
              <div className="female-show-services-comp-menu-nav-row  ">
                <div
                  className={`${ActiveService === "Hair Care" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={spypeIcon4} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div> Hair Care </div>
                </div>
              </div>

              {ActiveService === "Hair Care" ? (
                <div className="female-show-services-comp-ative-menu-content">
                  <div>
                    <p onClick={() => scrollToHeading("Hair Color")}>
                      {" "}
                      Hair Color{" "}
                    </p>
                    <p onClick={() => scrollToHeading("Hair Spa")}> Hair Spa</p>
                    <p onClick={() => scrollToHeading("Smoothening")}>
                      {" "}
                      Smoothening{" "}
                    </p>
                    <p onClick={() => scrollToHeading("Keratin")}>Keratin</p>
                    <p onClick={() => scrollToHeading("Kerasmooth")}>
                      Kerasmooth
                    </p>
                    <p onClick={() => scrollToHeading("Hairstyling")}>
                      {" "}
                      Hairstyling
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* <div className='female-show-services-comp-menu-nav-content'
          onClick={()=>handleServiceClick("Haircut")} 
          >
           

                     <div className='female-show-services-comp-menu-nav-row '>
                <div className={`${ActiveService === "Haircut" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={spypeIcon4} alt='i-c01'></img>  </div>  <div>Haircut</div>
                   </div>
                
                   </div>


                   
                </div> */}

            {/* <div className='female-show-services-comp-menu-nav-content'
                    onClick={()=>handleServiceClick("Head & Body Massage")}
                     >
         

                     <div className='female-show-services-comp-menu-nav-row '>
<div className={`${ActiveService === "Head & Body Massage" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={sypBDM} alt='i-c01'></img> </div>  <div>Head & Body Massage</div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
          

                </div> */}

            {/* 
                         <div className='female-show-services-comp-menu-nav-content'
                          onClick={()=>handleServiceClick("Mehdi")}
                           >
         

                     <div className='female-show-services-comp-menu-nav-row'>
                     <div className={`${ActiveService === "Mehdi" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={sypThreading} alt='i-c01'></img> </div>  <div>Mehdi</div>
                   </div>
                 


                   </div>
          

                </div> */}

            <div
              className="female-show-services-comp-menu-nav-content"
              onClick={() => handleServiceClick("Nail Art")}
            >
              <div className="female-show-services-comp-menu-nav-row">
                <div
                  className={`${ActiveService === "Nail Art" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}
                >
                  <div>
                    {" "}
                    <img src={sypThreading} alt="i-c01"></img>{" "}
                  </div>{" "}
                  <div>Nail Art </div>
                </div>
              </div>
            </div>

            {/* <div className='female-show-services-comp-menu-nav-content'
                          onClick={()=>handleServiceClick("Hair Dresser")} 
                          >
         

                     <div className='female-show-services-comp-menu-nav-row'>
<div className={`${ActiveService === "Hair Dresser" ? "female-show-services-comp-menu-nav-icon-row-active" : ""} female-show-services-comp-menu-nav-icon-row`}>
                   <div> <img src={spyIconhdres} alt='i-c01'></img> </div>  <div>Hair Dresser </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
          

                </div>  */}

            {/* 
       <div className='female-show-services-comp-menu-nav-content'>
               

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Pre-Bridal Sittings  </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                

                </div>


       <div className='female-show-services-comp-menu-nav-content'>
               

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Pre-Bridal Grooming  </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                 

                </div>


                
       <div className='female-show-services-comp-menu-nav-content'>
               

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Head & Body Massage </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                 

                </div> */}

            {/* <div className='female-show-services-comp-menu-nav-content'>
               

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Threading </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                

                </div> */}

            {/* <div className='female-show-services-comp-menu-nav-content'>
                 

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Hair Dresser </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
               

                </div> */}

            {/* <div className='female-show-services-comp-menu-nav-content'>
                 

                     <div className='female-show-services-comp-menu-nav-row'>
                    <div className='female-show-services-comp-menu-nav-icon-row'>
                   <div>  </div>  <div> Haircut </div>
                   </div>
                   <div>
                    <i class="fa-solid fa-angle-right"></i>
                   </div>


                   </div>
                 

                </div> */}
          </div>
        </div>

        {/* THIS MENU SECTION ONLY fOR PHONE VIEWS ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
 */}

        <div className="sab-meu-of-services-of-phone-views-female-services">
          {ActiveService === "wedding package" ? (
            <div className="female-show-services-comp-ative-menu-content female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("549 Deal")}> 549 deal</p>
                <p onClick={() => scrollToHeading("1099 Deal")}> 1099 deal</p>
                <p onClick={() => scrollToHeading("1599 Deal")}> 1599 deal</p>
                <p onClick={() => scrollToHeading("1999 Deal")}> 1999 deal</p>
                <p onClick={() => scrollToHeading("Advance Packages")}>
                  {" "}
                  Advance Packages
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "1rs services" ? (
            <div className="female-show-services-comp-ative-menu-content female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Free Waxing")}>
                  {" "}
                  Free Waxing
                </p>
                <p onClick={() => scrollToHeading("Free D Tan")}> Free D-Tan</p>
                <p onClick={() => scrollToHeading("Free Bleach")}>
                  {" "}
                  Free Bleach
                </p>
                <p onClick={() => scrollToHeading("Free Hair Color")}>
                  {" "}
                  Free Hair Color
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "waxing" ? (
            <div className="female-show-services-comp-ative-menu-content female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Honey Wax")}> Honey Wax</p>

                <p onClick={() => scrollToHeading("Rica Wax")}> Rica Wax</p>
                 <p onClick={() => scrollToHeading("Korean Wax")}>Korean Wax</p>
                {/* <p  onClick={() => scrollToHeading("Rica Roll On Wax")}> Rica Roll-on wax</p> */}
                <p onClick={() => scrollToHeading("Peel Off Wax")}>
                  Peel Off Wax
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "Facial Cleanup" ? (
            <div className="female-show-services-comp-ative-menu-content female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Facial")}> Facial</p>
                <p onClick={() => scrollToHeading("Cleanup")}> Cleanup</p>
                <p onClick={() => scrollToHeading("D-Tan")}>D-Tan</p>
                <p onClick={() => scrollToHeading("Threading")}>Threading</p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "Bleach & D-Tan" ? (
            <div className="female-show-services-comp-ative-menu-content   female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Bleach")}> Bleach</p>
                <p onClick={() => scrollToHeading("D-Tan")}> D-Tan</p>
                {/* <p  onClick={() => scrollToHeading("Bleach/D-tan with Scrub")}> Bleach/D-tan with Scrub</p> */}
                <p onClick={() => scrollToHeading("Scrub")}>Scrub</p>
                <p onClick={() => scrollToHeading("Body Polish")}>
                  Body Polish
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "Hair Care" ? (
            <div className="female-show-services-comp-ative-menu-content  female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Hair Color")}>
                  {" "}
                  Hair Color{" "}
                </p>
                <p onClick={() => scrollToHeading("Hair Spa")}> Hair Spa</p>
                <p onClick={() => scrollToHeading("Smoothening")}>
                  {" "}
                  Smoothening{" "}
                </p>
                <p onClick={() => scrollToHeading("Keratin")}>Keratin</p>
                <p onClick={() => scrollToHeading("Kerasmooth")}>Kerasmooth</p>
                <p onClick={() => scrollToHeading("Hairstyling")}>
                  {" "}
                  Hairstyling
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "Party Makeup" ? (
            <div className="female-show-services-comp-ative-menu-content  female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Party Makeup (Basic)")}>
                  {" "}
                  Party Makeup (Basic){" "}
                </p>
                <p onClick={() => scrollToHeading("Seasonal Makeup")}>
                  Seasonal Makeup
                </p>
                {/* <p  onClick={() => scrollToHeading("Hairstyling")}> Hairstyling</p> */}
                {/* <p  onClick={() => scrollToHeading("Basic Bridal Makeup")}> Basic Bridal Makeup</p>
                          <p  onClick={() => scrollToHeading("Bridal HD Makeup")}>Bridal HD Makeup</p> */}
              </div>
            </div>
          ) : (
            ""
          )}

          {ActiveService === "Bridal Makeup" ? (
            <div className="female-show-services-comp-ative-menu-content   female-show-services-comp-ative-menu-content-phone-views">
              <div>
                <p onClick={() => scrollToHeading("Basic Bridal Makeup")}>
                  {" "}
                  Basic Bridal Makeup
                </p>
                <p onClick={() => scrollToHeading("Bridal HD Makeup")}>
                  Bridal HD Makeup
                </p>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="female-show-services-comp-main-data-contatent">
          <LandingPackageComponent
            ActiveService={ActiveService}
            getHeadingRef={getHeadingRef}
            getSmHeadingref={getHeadingRef}
          />
        </div>
      </div>
    </div>
  );
}

export default FemaleServicesComponent